import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import GenericDivider from 'src/components/GenericDivider/GenericDivider';
import './preferred-times-summary.scss';

const SKELETON_TABS: number[] = [0, 1, 2, 3];
const SKELETON_SLOTS: number[] = [0, 1];

const PreferredTimesSummarySkeleton = () => {
  return (
    <>
      <div className="preferred-times-summary">
        <Skeleton variant="text" width="30rem" height={26} />
        <div className="time-slot">
          <div className="slot-control">
            <div className="summary-skeleton-tabs">
              {SKELETON_TABS.map((tab: number) => (
                <Skeleton
                  key={tab}
                  variant="rect"
                  width={72}
                  height={18}
                  className="summary-skeleton-bar"
                />
              ))}
            </div>
            <div className="summary-skeleton-slots">
              {SKELETON_SLOTS.map((slot: number) => (
                <Skeleton
                  key={slot}
                  variant="rect"
                  height={36}
                  className="summary-skeleton-bar"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <GenericDivider variant="sky" spacing="lg" />
    </>
  );
};

export default PreferredTimesSummarySkeleton;
